import React from 'react';

export default function Card(props) {
  return (
    <div className="flex justify-center items-center lg:mt-0 mt-[5%]">
      <div className="bg-white lg:relative static lg:bottom-14 bottom-0 flex flex-row justify-center items-center lg:w-1/2 w-2/3 rounded-[4px] shadow-event p-6">
        <div className="flex justify-center w-full">
          <div className="flex flex-col justify-center items-center text-center">
            <p className="text-[#999999] lg:text-xl md:text-base text-xs font-medium">
              {props.amountLeft}
            </p>
            <p className="text-[#999999] lg:text-xl md:text-base text-xs">{props.textLeft}</p>
          </div>
        </div>
        <hr className="border border-[#EAEAEA] w-0.5 h-[80px] lg:mx-0 mx-3" />
        <div className="flex justify-center w-full">
          <div className="flex flex-col justify-center items-center text-center">
            <p className="text-[#999999] lg:text-xl md:text-base text-xs font-medium">
              {props.amountCenter}
            </p>
            <p className="text-[#999999] lg:text-xl md:text-base text-xs">{props.textCenter}</p>
          </div>
        </div>
        <hr className="border border-[#EAEAEA] w-0.5 h-[80px] lg:mx-0 mx-3" />
        <div className="flex justify-center w-full">
          <div className="flex flex-col justify-center items-center text-center">
            <p className="text-[#999999] lg:text-xl md:text-base text-xs font-medium">
              {props.amountRight}
            </p>
            <p className="text-[#999999] lg:text-xl md:text-base text-xs">{props.textRight}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
